import { Link } from "react-router-dom";
import { usePageSeo } from "@/hooks/usePageSeo";

const principles = [
  { icon: "ri-verified-badge-line", title: "内容多样", desc: "娱乐八卦、综艺现场、社会热点与网络热梗并重，频道丰富，拒绝单调。" },
  { icon: "ri-timer-line", title: "更新及时", desc: "围绕实时热点滚动更新，让你第一时间跟上全网吃瓜节奏。" },
  { icon: "ri-eye-line", title: "浏览轻松", desc: "免下载直接打开、网页在线看，手机电脑自适应，零门槛随时浏览。" },
  { icon: "ri-shield-check-line", title: "来源客观", desc: "基于公开信息做资讯梳理与趋势解读，标题与内容保持一致。" },
];

const voices = [
  { name: "追剧的桃子", role: "综艺迷", text: "下班通勤在地铁上用手机就能直接打开看，不用下载任何东西，太方便了，更新也够快。" },
  { name: "摸鱼老王", role: "热点冲浪选手", text: "热点榜把一天的重点都整理好了，话题分类很清楚，想吃什么瓜自己挑，效率翻倍。" },
  { name: "江边的喵", role: "资讯读者", text: "内容不水，不是那种标题党的堆砌，会认真讲背后的门道，比单纯吃瓜有营养多了。" },
];

const stats = [
  { num: "4+", label: "核心内容频道" },
  { num: "免下载", label: "在线直接看" },
  { num: "多端", label: "手机电脑自适应" },
  { num: "每日", label: "实时滚动更新" },
];

export default function About() {
  usePageSeo({
    title: "关于我们 - 吃瓜现场 | 热点娱乐八卦资讯平台介绍",
    description:
      "了解吃瓜现场：一个专注娱乐八卦、综艺现场与全网热讯的实时浏览资讯平台。坚持内容多样、更新及时、浏览轻松、免下载网页在线看，手机电脑自适应。",
    ld: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于吃瓜现场",
      inLanguage: "zh-CN",
      description: "关于吃瓜现场平台定位、内容原则与联系方式的介绍页面。",
    },
  });

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
      <nav className="flex items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑">
        <Link to="/" className="hover:text-primary-700">首页</Link>
        <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
        <span className="text-foreground-950">关于我们</span>
      </nav>

      {/* 页头 */}
      <header className="mt-6 rounded-3xl bg-foreground-950 px-6 py-12 text-center md:px-10 md:py-16">
        <p className="text-xs font-semibold uppercase tracking-widest text-secondary-300">About ChiguaXianchang</p>
        <h1 className="mt-3 font-heading text-3xl font-black tracking-tight text-background-50 md:text-5xl">
          关于吃瓜现场
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-200 md:text-base">
          我们是一群热爱围观、也认真做内容的朋友。吃瓜现场想做的，是把全网最值得聊的热点八卦与新鲜资讯，整理成一份「免下载、在线看、实时刷新」的轻松读物。
        </p>
      </header>

      {/* 关键数据 */}
      <section className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4" aria-label="平台数据">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl border border-background-200/70 bg-background-100/50 p-5 text-center">
            <p className="font-heading text-2xl font-black text-primary-500 md:text-3xl">{s.num}</p>
            <p className="mt-1.5 text-sm text-foreground-700">{s.label}</p>
          </div>
        ))}
      </section>

      {/* 品牌故事 */}
      <section className="mt-12 grid grid-cols-1 items-center gap-8 lg:grid-cols-2" aria-labelledby="story-title">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20modern%20illustration%20of%20a%20cozy%20group%20of%20friends%20around%20a%20watermelon%20picnic%20reading%20news%20on%20phones%20and%20tablet%2C%20lively%20yet%20relaxed%20atmosphere%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20sage%20green%20and%20soft%20peach%20color%20palette%2C%20subtle%20film%20grain%2C%20soft%20studio%20lighting%2C%20generous%20negative%20space%2C%20clean%20modern%20editorial%20digital%20art&width=1200&height=900&seq=about-story-01&orientation=landscape"
          alt="吃瓜现场的创作与浏览氛围"
          title="关于吃瓜现场 - 吃瓜现场"
          className="aspect-[4/3] w-full rounded-3xl object-cover"
        />
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-500">Who We Are</p>
          <h2 id="story-title" className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            我们是谁，想做成什么样
          </h2>
          <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            <p>
              「吃瓜」从来不是无聊的围观，而是大家对正在发生的事保持好奇心与参与感的方式。我们希望吃瓜现场成为你了解娱乐八卦、综艺现场与全网热讯的轻量入口。
            </p>
            <p>
              在这里，不需要下载任何应用，也无需繁琐的注册，网页在线看、直接打开即可浏览。手机版与电脑版自动适配，走到哪都能实时跟上热点，随时随地轻松开席。
            </p>
          </div>
        </div>
      </section>

      {/* 定位理念 */}
      <section className="mt-12 rounded-3xl bg-background-100/60 p-6 md:p-10" aria-labelledby="concept-title">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Our Concept</p>
          <h2 id="concept-title" className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            定位与理念
          </h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="rounded-2xl bg-background-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
              <i className="ri-collage-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">聚合型资讯浏览</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              打破单一信息源，按频道聚合热点，让浏览变得省心高效。
            </p>
          </div>
          <div className="rounded-2xl bg-background-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
              <i className="ri-message-2-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">陪伴式讨论</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              不止给你瓜，更带你读懂瓜背后的趋势、门道与生活方式。
            </p>
          </div>
          <div className="rounded-2xl bg-background-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-100 text-secondary-800">
              <i className="ri-magic-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">轻松无负担</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              免下载、直接打开、无需注册，把复杂留给技术，把轻松留给你。
            </p>
          </div>
        </div>
      </section>

      {/* 内容原则 */}
      <section className="mt-12" aria-labelledby="principle-title">
        <p className="text-xs font-semibold uppercase tracking-widest text-primary-500">Content Principle</p>
        <h2 id="principle-title" className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          我们的内容原则
        </h2>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div key={p.title} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-background-100 text-primary-600">
                <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="mt-12" aria-labelledby="voice-title">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">What Readers Say</p>
          <h2 id="voice-title" className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            读者怎么说
          </h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {voices.map((v) => (
            <figure key={v.name} className="flex flex-col rounded-2xl bg-background-100/60 p-6">
              <i className="ri-double-quotes-l text-3xl text-primary-300" aria-hidden="true"></i>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">“{v.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                  {v.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{v.name}</span>
                  <span className="text-xs text-foreground-600">{v.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系 */}
      <section className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2" aria-label="联系我们">
        <div className="rounded-3xl bg-foreground-950 p-6 md:p-8">
          <h2 className="font-heading text-2xl font-black text-background-50">联系与投稿</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-200">
            有独家线索、内容建议或合作意向？欢迎通过下方邮箱与我们交流，优质瓜料与选题都会被认真对待。
          </p>
          <a
            href="mailto:contact@example-cg.cn"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            <i className="ri-mail-send-line text-base" aria-hidden="true"></i> contact@example-cg.cn
          </a>
        </div>
        <div className="flex flex-col justify-between rounded-3xl bg-accent-900 p-6 text-accent-50 md:p-8">
          <div>
            <h2 className="font-heading text-2xl font-black text-background-50">想第一时间吃瓜？</h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-100/90">
              订阅快讯，或去热点榜看看大家都在关注什么。免下载、在线看、多端适配，随时开席。
            </p>
          </div>
          <div className="mt-6 flex flex-wrap gap-2.5">
            <Link to="/" className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-accent-900 hover:bg-accent-100">
              去首页订阅
            </Link>
            <Link to="/faq" className="inline-flex items-center gap-1.5 rounded-full bg-accent-700/60 px-4 py-2 text-sm text-background-50 hover:bg-accent-600">
              查看常见问题
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}